import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { TextBase } from "../../internal/TextBase";
import styles from '../PageNavigator.css';
export var Ellipsis = function Ellipsis(_ref) {
  var restProps = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
    className: styles.ellipsis
  }), /*#__PURE__*/React.createElement(TextBase, {
    size: "l",
    color: "N100"
  }, "..."));
};